export default [
  { label: "Status", value: "status" },
  { label: "Tipo", value: "type" },
  { label: "Valor do pagamento", value: "paid_total" },
  { label: "Data de emissão", value: "issued_at" },
  { label: "Data de pagamento", value: "paid_at" },
  { label: "Data de cancelamento", value: "canceled_at" },
  { label: "Ações", value: "actions", className: "w-9" },
];
